import { clickDownloadElement, downloadOrViewArquivo } from '@app/helpers/download';
import api from '../api';
import { CondicoesComerciasProps, SasPropostaProps } from './ordemCompra';
import { trackPromise } from 'react-promise-tracker';
import Axios from 'axios';
import { DadosAbaSumario } from '../demanda';
import { getJwt } from '@app/helpers';

const controller = 'rhSas';

export interface RelatorioHomologacaoProps {
  analistaSuprimentos: string;
  areaRequisitante: string;
  caracteristicaOc: string;
  contrato: number;
  id: string;
  justificativaContratacao: string;
  menorPcEqualizada: number;
  naturezaContabil: number;
  nomePropostaPremiada: string;
  numeroOc: number;
  objetoASerContratado: string;
  orcamento: number;
  ordemCompraId: string;
  prazoExecucao: number;
  previstoOrcamento: string;
  sasProposta: any[];
  solicitante: string;
  terminoVigenciaAditivo: string;
  tipoOc: number;
  valorAContratar: number;
  valorAditivo: number;
  anexoId: string;
  anexoNome: string;
  condicoesComerciais: CondicoesComerciasProps[];
  modalidadeContratoTotvs: string;
  moeda: string;
  sasPropostas: SasPropostaProps[];
  valorPropostaPremiada: number;
  gerenteCompras: string;
  gerenteSuprimentos: string;
  diretorEspecifico: string;
  diretoriaComercial: string;
  diretorPresidente: string;
  historicoProcessoCompra: string;
  statusCodigo: number;
  demandaId: string;
  compradorId: string;
  dataEmissao: Date;
  isFornecedorDirecionado: boolean;
  isVisitaTecnica: boolean;
  isEmergencial: boolean;
  gestorTecnicoId: string;
  gerenteAreaId: string;
  minimoProponentes: number;
  comentarioGerenteArea: string;
  statusOrdemCompraId: string;
  aprovacaoGerenteAquisicoesStatus: string;
  aprovacaoGerenteGeralStatus: string;
  aprovacaoDocusignStatus: string;

  sumario: DadosAbaSumario;

  dataInicioAditivo?: Date;
  dataTerminoAditivo?: Date;

  tipoAditivo?: string;

  valorCalcRH: number;
}

export interface RelatorioHomologacaoAprovacao {
  id: string;
  status: string;
  aprovador: string;
  justificativa: string;
  tipoAprovacao: string;
  data: Date;
}

export const getRelatorioHomologacao = (ordemCompraId: string) =>
  api.get<RelatorioHomologacaoProps>(`${controller}/${ordemCompraId}`);

export const getRelatorioHomologacaoObservacao = (ordemCompraId: string) =>
  api.get<any>(`${controller}/observacao/${ordemCompraId}`);

export const onRelatorioHomologacao = (ordemCompraId: string, values: any) =>
  api.put(`${controller}/${ordemCompraId}`, values);

export const onRelatorioHomologacaoObservacao = (ordemCompraId: string, values: any) =>
  api.put(`${controller}/observacao/${ordemCompraId}`, values);

export const enviarContratoTotvs = (ocId: string, clausulas?: string[]) =>
  api.put(`${controller}/enviarContratoTotvs`, { ordemCompraId: ocId, clausulas });

export const emitirContratoTotvs = (ocId: string) =>
  api.put(`${controller}/emitirContratoTotvs`, { ordemCompraId: ocId });

export const getAnexoRelatorioHomologacao = (id: string, fileName: string) =>
  api.downloadFile(`${controller}/anexo/${id}`, fileName);

export const downloadAnexoRelatorioHomologacaoAprovacao = (id: string, nomeDoArquivo: string) => {
  downloadOrViewArquivo({
    url: `/api/${controller}/anexoAprovacao/${id}`,
    nomeDoArquivo,
    atributoId: 'downloadAnexoRelatorioHomologacaoAprovacao'
  });
};

export const viewAnexoRelatorioHomologacaoAprovacao = async (id: string, nomeDoArquivo: string) => {
  downloadOrViewArquivo({
    url: `/api/${controller}/anexoAprovacao/${id}`,
    nomeDoArquivo,
  }, true);
};

// export const getTemplateRelatorioHomologacao = (ordemCompraId: string, fileName: string) =>
//   api.downloadFile(`${controller}/exportacao/${ordemCompraId}`, fileName);

export const enviarParaAprovacao = (ordemCompraId: string) =>
  api.post(`${controller}/enviarAprovacao`, { ordemCompraId });

export const aprovarRelatorioHomologacao = (ordemCompraId: string, justificativa: string) =>
  api.post(`${controller}/aprovar`, { ordemCompraId, justificativa });

export const reprovarRelatorioHomologacao = (form: any) =>
  api.post(`${controller}/reprovar`, form);

export const getAprovacoes = (ordemCompraId: string) =>
  api.get<RelatorioHomologacaoAprovacao[]>(`${controller}/aprovacoes/${ordemCompraId}`);

export const concluirRH = (ordemCompraId: string) => api.post(`${controller}/concluirRH/${ordemCompraId}`);

export const getTemplateRelatorioHomologacao = (ordemCompraId: string) => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/${controller}/exportacao/${ordemCompraId}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    })
      .then(resp => {
        //Get filename from response header
        let headerLine = resp.headers['content-disposition'];
        let contents = headerLine.split('; ');
        let filename = '';
        contents.forEach(element => {
          if (element.includes('filename=')) {
            filename = element.replace('filename=', '').replaceAll('"', '').replace(/={1}/g, '%').replaceAll('+', ' ');
            filename = decodeURI(filename);
          }
        });
        if (filename !== '') {
          const url = window.URL.createObjectURL(new Blob([resp.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          link.setAttribute('id', 'downloadArquivo');
          document.body.appendChild(link);
          link.click();
          document.getElementById('downloadArquivo').outerHTML = '';
        }
      })
      .catch(error => {
        if (error.response) {
          notification.error('Houve um erro ao exportar.');
        }
      }),
  );
};

export const getChecklistReajuste = (ordemCompraId: string) =>
  api.get<any>(`${controller}/checklistReajuste/${ordemCompraId}`);

export const putChecklistReajuste = (ordemCompraId: string, body: any) =>
  api.put<any>(`${controller}/checklistReajuste/${ordemCompraId}`, { respostas: body });

export const postCkRhComentario = (ckRhId: string, comentario: string) =>
  api.post<any>(`${controller}/checklistReajuste/${ckRhId}/comentario`, { comentario });

export const getCkRhComentario = (passoId: string) =>
  api.get(`${controller}/checklistReajuste/${passoId}/comentario`);

export const getExcelChecklistReajuste = (ordemCompraId: string) => {
  downloadOrViewArquivo({
    url: `/api/${controller}/checklistReajuste/${ordemCompraId}/exportar`,
    nomeDoArquivo: `cheklist_reajuste.xlsx`,
    atributoId: 'downloadExcelChecklistReajuste'
  });
};
